import { PassengerTypeDTO } from '@shared/service-proxies/service-proxies';

export function getNumberOfPassenger(passengers: PassengerTypeDTO[]): number {
    let numberOfPassenger = 0;
    passengers.map(el => {
        numberOfPassenger += el.quantity;
    });
    return numberOfPassenger;
}
